import parser from 'ua-parser-js'

export const getUserBrowser = () => {
  const ua = parser(navigator.userAgent)
  return { browserName: ua.browser.name, browserVersion: ua.browser.version }
}

export const getOSDetails = () => {
  const ua = parser(navigator.userAgent)
  return { osVersion: ua.os.version, osName: ua.os.name }
}
